import classNames from "classnames";
import React, { useEffect, useRef, useState } from "react";
import { CustomIcon } from "../../components";
import Cookies from "js-cookie";
import constants from "../../values/constants";
import "./index.scss";

type Props = {
  children: React.ReactNode;
  title?: string;
  dd_side?: "left" | "right";
  min_width?: string;
  hoverTitle?: string;
};
const userDirection = Cookies.get(constants.USER_DIRECTION);
const DropdownFilter = ({
  children,
  title,
  dd_side = userDirection === "ltr" ? "right" : "left",
  min_width,
  hoverTitle = "فیلتر",
}: Props) => {
  const refActiveFilter = useRef<HTMLInputElement | null>(null);
  const [isActiveFilter, setIsActiveFilter] = useState<boolean>(false);

  useEffect(() => {
    document.addEventListener("mousedown", (event: any) => {
      if (!refActiveFilter?.current?.contains(event.target)) {
        setIsActiveFilter(false);
      }
    });
  }, []);

  return (
    <section id="dropdown-filter-content" ref={refActiveFilter}>
      {/* Filter Button */}
      <CustomIcon
        icon="fa-sharp fa-solid fa-bars-staggered"
        size="medium"
        hoverTitle={hoverTitle}
        onClick={() => {
          setIsActiveFilter(!isActiveFilter);
        }}
      />
      {/* Filter Dropdown */}

      {isActiveFilter && (
        <div
          className={classNames(
            "filter-dropdown",
            dd_side,
            dd_side === "left"
              ? isActiveFilter
                ? "open_l"
                : "close"
              : isActiveFilter
              ? "open"
              : "close"
          )}
          style={{ minWidth: min_width }}
        >
          <div className="filter-header">
            <span className="header-title">{title}</span>
            <i
              id="x-icon"
              className="fa-solid fa-xmark"
              onClick={() => setIsActiveFilter(false)}
            />
          </div>
          <div className="filter-body">{children}</div>
        </div>
      )}
    </section>
  );
};

export default DropdownFilter;
